module.exports = __webpack_public_path__ + "images/accents/signature@2x-dfe7a890eaa8e8f73101dc23b35c6530.webp";